/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useRef, useState } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import IdentificationHeader from './IdentificationHeader';
import ChoiceSection from '../../components/ChoiceSection';
import ApplicationContext from '../../context/ApplicationContext';
import { dataService } from '../../services/data.service';
import BackButton from '../../components/Button/BackButton';
import { identificationLanguageContent } from './IdentificationLanguageContent';

function PhotoChoice(props) {
    const { handlePage, setIdCardData, sessionData, selectedLanguage } = useContext(ApplicationContext);
    
    const [selectedChoice, setSelectedChoice] = useState('');

    const handleNavigation = (choice) => {
        if(choice === 'Upload') {
            handlePage('upload_id_image', '', '', sessionData['review'] === 'previous' ? 'previous' : '')
        } else {
            handlePage('take_id_image', '', '', sessionData['review'] === 'previous' ? 'previous' : '')
        }
    }

    const getIdentityCardDetails = () => {
        dataService.getIDCardDetails(sessionStorage.getItem('session')).then((res) => {
            if(res.error === false) {
                setIdCardData(res.data.data);
            }
        })
    }

    const handleBack = () => {
        handlePage('identity', '', '', sessionData['review'] === 'previous' ? 'previous' : '');
    }

    useEffect(() => {
        getIdentityCardDetails();
    }, []);

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-auto'>
            <IdentificationHeader />
            <div className='p-[8px] overflow-x-hidden overflow-y-auto options-height Form-scroll mt-[18px] '>
                <div className='mx-[12px] '>
                    {identificationLanguageContent['photo-choice'][selectedLanguage]}
                    <div className='mt-[38px]'>
                        <ChoiceSection question="" choice1="Upload" choice2="Take a photo"  selectedChoice={selectedChoice} setSelectedChoice={setSelectedChoice} event="id" callback={true} handleNext={handleNavigation} />
                    </div>
                </div>
            </div>
            <div className='flex mb-[24px] justify-between mx-[16px] w-[40%] fold-gap pt-[20px]'>
                <BackButton handleClick={() => handleBack()} backType="previous" />
            </div>
        </AnimatedPageFade>
    );
}

export default PhotoChoice;